import { useRef } from 'react';
import { DISPLAY_MODES, LANGUAGES, nativeName } from '../lib/languages.js';
import { useOutsideClick } from '../hooks/useOutsideClick.js';

export function LangSwitcher({
  lang,
  mode,
  onChooseLang,
  onChooseMode,
  onOpenDisclaimer,
  open,
  onToggle,
  onClose,
}) {
  const toggleRef = useRef(null);
  const dropdownRef = useRef(null);

  useOutsideClick(open, [toggleRef, dropdownRef], onClose);

  return (
    <div className="lang-switcher">
      <button
        ref={toggleRef}
        className="lang-toggle-btn"
        aria-label="Change language"
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
      >
        <span className="lang-icon">&#127760;</span>
        <span>{nativeName(lang)}</span>
      </button>

      <div ref={dropdownRef} className={`lang-dropdown${open ? ' open' : ''}`}>
        {LANGUAGES.map((l) => (
          <button
            key={l.code}
            className={`lang-option${l.code === lang ? ' active' : ''}`}
            data-lang={l.code}
            onClick={() => {
              onChooseLang(l.code);
              onClose();
            }}
          >
            <span className="lang-native">{l.native}</span>
            {l.english && <span className="lang-english">{l.english}</span>}
            <span className="lang-check">&#10003;</span>
          </button>
        ))}

        <div
          className="lang-ai-note"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
            onOpenDisclaimer();
          }}
        >
          AI Translation &#8212; click for details
        </div>

        <div className="lang-mode-toggle">
          {DISPLAY_MODES.map((m) => (
            <button
              key={m.id}
              className={`lang-mode-btn${m.id === mode ? ' active' : ''}`}
              data-mode={m.id}
              onClick={(e) => {
                e.stopPropagation();
                onChooseMode(m.id);
              }}
            >
              {m.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
